module.exports = __webpack_public_path__ + "images/individual_avatar.8c53270aff38c53857a04fd86a60e56a.png";